import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter003() {
  return <KbChapterPage slug="chapter-003" />;
}

(Chapter003 as unknown as { path: string }).path = "/theory-album/003";
